module.exports = __webpack_public_path__ + "static/media/edited1.749cc178.svg";